import React, { useEffect, useState } from 'react';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'leo_delivery_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const storedConsent = window.localStorage.getItem(STORAGE_KEY);
      setVisible(!storedConsent);
    } catch (error) {
      setVisible(true);
    }
  }, []);

  const saveConsent = (status) => {
    const consent = {
      status,
      decidedAt: new Date().toISOString(),
      version: '1.0'
    };

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch (error) {
      // If storage is unavailable, hide the banner for the current session.
    }

    window.dispatchEvent(new CustomEvent('CookieConsentUpdated', { detail: consent }));
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <aside className="cookie-consent" aria-label="Aviso de cookies">
      <div className="cookie-consent__icon" aria-hidden="true">
        <Cookie size={22} />
      </div>
      <div className="cookie-consent__content">
        <strong>Usamos cookies para melhorar sua experiência.</strong>
        <p>
          Cookies essenciais mantêm o site funcionando. Cookies de análise e marketing
          só devem ser usados quando você aceitar.
        </p>
      </div>
      <div className="cookie-consent__actions">
        <button
          type="button"
          className="btn btn-outline-custom btn-sm"
          onClick={() => saveConsent('rejected')}
        >
          Rejeitar
        </button>
        <button
          type="button"
          className="btn btn-primary-custom btn-sm"
          onClick={() => saveConsent('accepted')}
        >
          Aceitar
        </button>
      </div>
    </aside>
  );
};

export default CookieConsent;
